const RECENT_KEY = 'vaultnotes_recent_notes';
const MAX_RECENT = 20;

export function getRecentNotes() {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
  } catch {
    return [];
  }
}

export function trackNoteView(noteId, title) {
  if (!noteId) return;
  const recent = getRecentNotes().filter((r) => r.id !== noteId);
  recent.unshift({ id: noteId, title: title || 'Untitled', viewedAt: Date.now() });
  localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
}

export function clearRecentNotes() {
  localStorage.removeItem(RECENT_KEY);
}
